import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditMissionObjectiveLayout from '../layouts/EditMissionObjectiveLayout';
import {MissionObjective} from "../../../classes/MissionObjective";
import {Mission} from "../../../classes/Mission";

function NewMissionObjectiveModal(props: {
    missionData: Mission,
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function
}) {

    const newObjective = new MissionObjective()
    newObjective.missionId = props.missionData.id!

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditMissionObjectiveLayout
                    title="Create Objective"
                    initInfo={newObjective}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewMissionObjectiveModal;